import { useGetScheduledNotifications as useGetScheduledNotificationsGenerated } from "@/api/generated";

export const useGetScheduledNotifications = () => {
  return useGetScheduledNotificationsGenerated();
};
